import { gql } from '@apollo/client';
import { useMutation } from 'platform/useMutation';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export const ViewedSSVA = gql`
  mutation ViewedSSVA($sellerLeadUUID: String!) {
    sellDirect {
      viewedSSVAPage(input: { lead: { source: { type: RECEPTION, id: $sellerLeadUUID } } }) {
        success
      }
    }
  }
`;
/** Mutation that triggers whenever a user lands on the ssva upload experiment page for the first time */
export const useViewedSSVA = () => {
  const { sellerInputUUID } = useQualificationContext();
  const [viewedSSVA, { loading, data, error }] = useMutation(ViewedSSVA, {
    fetchPolicy: 'no-cache',
  });
  const updateViewedSSVA = () =>
    viewedSSVA({
      variables: { sellerLeadUUID: sellerInputUUID },
    });
  return { updateViewedSSVA, loading, data, error };
};
